module.exports = __webpack_public_path__ + "static/media/photoImage.07c393d8.png";